import React from 'react';
import { connect } from "react-redux";
import moment from 'moment';
import { intlShape } from 'react-intl';
import {isEmpty, get} from "lodash";

import { findCustomer, closeRefresh } from "./../../actions/CustomerActions";
import { getCustomerConfiguration } from "./../../actions/ListActions";
import { getSignedPdf } from '../../actions/SubscriptionActions';
import {loadPaymentSession, confirmHostedCheckout, clearPaymentStatus} from "../../actions/PaymentActions";

import LocalStorageService from '../../services/LocalStorageService';

import PaymentMethod from "./PaymentMethod.jsx";
import CoordinateDialog from "./CoordinateDialog.jsx";

import {getUrlParameters} from '../../../opencell/pages/utils/UrlUtils';

@connect(( store ) => {
    return {
        subscription: store.subscription.subscription,
        messages: store.messages.messages,
        listData: store.customerConfig.listData,
        refresh: store.customer.refresh || false,
        userAccount: store.account.userAccount || {},
        customerAccount: store.account.userAccount.billingAccount.customerAccount || {},
        procedure: store.subscription.procedure,
        payment: store.payment || {}
    }
} )
export default class MyCoordinates extends React.Component {
	static propTypes = {
		intl: intlShape
	}
	constructor() {
		super();
    this.state = {
      showIngenicoStatus: false
  }
  };

		componentDidMount() {
			const { dispatch } = this.props;
			dispatch( getCustomerConfiguration() );

      // load payment details from session to store
      const {sessionId = ""} = getUrlParameters();
      const sessionState = LocalStorageService.get(sessionId, {});
      if (sessionId && !isEmpty(sessionState)) {
        dispatch(loadPaymentSession(sessionState));
        // Clear session state
        LocalStorageService.remove(sessionId);
      }
    }

    componentDidUpdate = () => {
      const {payment= {}, dispatch} = this.props;
      const {showIngenicoStatus} = this.state;
      const { hostedCheckoutUrl = "", status={} } = payment;
      const { hostedCheckoutConfirmed = false, paymentStatus="" } = status;
      if(hostedCheckoutUrl && !hostedCheckoutConfirmed ) {
        dispatch(confirmHostedCheckout());
      }
      if (hostedCheckoutConfirmed && paymentStatus != "ACCEPTED" && paymentStatus != "PENDING" && !showIngenicoStatus) {
        dispatch(clearPaymentStatus());
        this.setState({showIngenicoStatus : true})
      }
    };
    
    componentWillReceiveProps(nextProps){
        if(nextProps.refresh){
          const { dispatch } = this.props;
          this.props.dispatch(closeRefresh());
        }
    }

    renderDirectDebit = (paymentMethod) => {
      const {messages } = this.props;
      const {bankCoordinates = {}} = paymentMethod || {};
      const {iban = ""/*, bic=""*/} = bankCoordinates || {};
      const encryptedIban = `${iban.slice(0, 4)}XXXXXXXXXXXXXXXXXXXX${iban.slice(-2) || ""}`;
      return (
          <div className="text-left" >
            <p>
              <label className="text-label grey-blue-color">{messages["common.label.payment.method"]}: </label>
              <label className="text-value">{messages["common.label.sepa"]}</label>
            </p>
            <p>
              <label className="text-label grey-blue-color">{messages["common.label.iban"]}: </label>
              <label className="text-value">{encryptedIban}</label>
            </p>
            {/* <p>
              <label className="text-label grey-blue-color">{messages["common.label.bic"]}: </label> 
              <label className="text-value">{bic}</label>
            </p> */}
          </div>

      )
    }

    renderIngenico = (paymentMethod) => {
      const { messages } = this.props;
      const {owner, monthExpiration , yearExpiration, alias} = paymentMethod || "";
      const expirationDate = monthExpiration + "/" +  yearExpiration;
      const currentDate = moment(Date.now()).format("YYYY/MM/DD");
      const currentMonth = new Date().getMonth();
      const currentYear = new Date().getFullYear().toString().substr(-2);
      const soonExpiration =  monthExpiration -  (currentMonth + 1 );

      return (
        <div className="text-left" >
          <h5> {messages["common.label.credit.card.info"]}: {`XXXX XXXX XXXX ${alias}`}</h5>
          <h5>{messages["common.label.payment.method"].toLowerCase()} : {messages["common.label.cb"]}</h5>
          <h5>{messages["common.label.end.date"]} : {expirationDate}</h5>
          <h5>{messages["common.label.holder"]} : {owner}</h5>
          {soonExpiration < 2  && yearExpiration <= parseInt(currentYear)  &&
            <p style={{ color: 'red' }}>{messages["common.block.expiration.cb"]} </p>
          }
        </div>
      )
    }

    downloadSignedPdf = (fileNameSuffix) => () => {
      const { dispatch, procedure = {} } = this.props;
      const { files = []} = procedure;
      const fileData = (files || []).find(file => (file.name || "").endsWith(fileNameSuffix));
      !isEmpty(fileData) && dispatch(getSignedPdf(fileData));
    };

    render() {
      const { dispatch, listData, userAccount, subscription, customerAccount, procedure, messages, payment={}} = this.props;
      const {showIngenicoStatus} = this.state;
      const { titles } = listData || {};

      const {name ={}, address={}, contactInformation={}} = customerAccount || {};
      const {address1="", address2="", address3="", zipCode="", city=""} = address || ""
      const {title={}, lastName="", firstName=""} = name ||""
      const {code=""} = title ||""
      const globalAddress = address1  + " " + address2  + " " + address3;
      const titulaire =  code + " " + lastName + " " + firstName ;
      const postalCode = zipCode  + " " + city;
      const {email="", mobile=""} = contactInformation;
      const {paymentMethods} = customerAccount || {};
      const paymentMethod = !isEmpty(paymentMethods) &&  Object.values(paymentMethods).find(paymentMethod => paymentMethod.preferred === true)
      const {paymentType=""} = paymentMethod || {};
      const { offer = {}, code:subscriptionCode = "" } = subscription || {};
      const CF_CUST_MEMBER_ID = get(customerAccount, `cfValues.valuesByCode.${CUSTOMER_MEMBER_ID}.0.value`, null);
      // check if SEPA file exist
      const { files = []} = procedure || {};
      const fileData = (files || []).find(file => (file.name || "").endsWith("SEPA"));
      const foundSepaFile = !isEmpty(fileData);
      /* ---------------------- */
      const {status={}} = payment || {};
      const {paymentStatus = "", hostedCheckoutConfirmed=false} = status
     return (
        <div id="myAccount-page">
          <div className="col-md-12">
            <div className="col-md-8">
                <p className="title stat-panel"> {messages["common.label.my.info"]}</p>
            </div>
          <div id="mesCoordonnes-page">
            {
                !isEmpty(paymentMethod) && !!subscription && !!offer &&
                    <li>
                        <div className="col-md-12">
                          <div className="box-amount-small col-md-11">
                            <div className="col-md-6">
                              <h5><label class="text-label grey-blue-color">{messages["common.label.num.contrat"]} : </label>
                                <label className='text-value'>{subscriptionCode}</label>
                              </h5>
                              <h5 className="small-size"> <label className="text-label grey-blue-color"> {messages["common.label.num.card"]} : </label>
                                <label className="text-value">{CF_CUST_MEMBER_ID}</label>
                              </h5>
                              <div className="text-marginLeft">
                                <div className="text-marginTop">
                                  <label className="sousTitle title-of-box">{messages["common.label.payment.method"]}</label>
                                </div>
                                {paymentType === "DIRECTDEBIT" && this.renderDirectDebit(paymentMethod)}
                                {paymentType === "CARD" && this.renderIngenico(paymentMethod)}

                                {
                                hostedCheckoutConfirmed && showIngenicoStatus && (paymentStatus === "REJECTED" || paymentStatus === "ERROR") ?
                                    <h2 className="error-color">{messages["payment.method.failed"]}</h2>
                                    :null
                                }
                                <PaymentMethod/>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="text-left">
                                <div className="sousTitle title-of-box">
                                  {messages["common.label.my.details"]}
                                </div>
                                <div className="text-left">
                                  <p><label className="text-label grey-blue-color">{messages['common.label.holder']}: </label>
                                    <label className="text-value">{titulaire}</label>
                                  </p>
                                  <p><label className="text-label grey-blue-color">{messages['common.label.email.contact']}: </label>
                                    <label className="text-value">{email}</label>
                                  </p>
                                  <p><label className="text-label grey-blue-color">{messages['common.label.num.telephone']}: </label>
                                    <label className="text-value">{mobile}</label>
                                  </p>
                                </div>
                                {/* <CoordinateDialog messages={messages} dialogTitle={messages["common.label.update.details"]} button={messages["common.label.update.details"]} customerAccount={customerAccount} /> */}
                              </div>
                              <div className="text-left ">
                                <p className="text-label grey-blue-color">
                                  {messages["common.label.address"]}{":"}
                                </p>
                                <div className="text-left" >
                                  <p className="text-value">{globalAddress}</p>
                                  <p className="text-value">{postalCode}</p>
                                </div>
                                {/* <CoordinateDialog titles={titles} messages={messages} dialogTitle={messages["common.label.update.address"]} button={messages["common.label.update.address"]} customerAccount={customerAccount} /> */}
                              </div>
                              <div className="stat-panel">
                                <div className="sousTitle title-of-box">
                                  {messages["common.label.my.documents"]}
                                </div>
                                <div className="box-amount-small">
                                  <div className="text-center">
                                    <div className="col-md-12 link-anchor">
                                      <a onClick={!!subscription && this.downloadSignedPdf("Contrat")}>{messages["common.label.contrat"]}</a>
                                    </div>
                                    <div className="col-md-12 link-anchor">
                                      <a onClick={!!subscription && this.downloadSignedPdf("SEPA")} disabled={!foundSepaFile}>{messages["common.label.mondat.sepa"]}</a> 
                                    </div>
                                    <div className="col-md-12 link-anchor">
                                      <a onClick={!!subscription && this.downloadSignedPdf("TERMS")}>{messages["common.label.terms"]}</a>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                    </li>
                }
          </div>
          </div>
        </div >
      )
  }
}



// WEBPACK FOOTER //
// ./src/opencell/pages/client/MyCoordinates.jsx